import { Injectable } from "@angular/core";
import { IID_UNLOCK_CODE } from "@common/interfaces/interfaceData";
import { ID } from "@common/interfaces/id";
import { InterfaceName } from "@common/interfaces/issueTypeInterface";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { PersistedStoreConfig } from "@persistence/persisted-store-config";
import { InterfaceDataStore } from "../interfaceDataRegistry";

export interface IIDUnlockCodeState extends EntityState<IID_UNLOCK_CODE, ID> {}

@Injectable({ providedIn: 'root' })
@PersistedStoreConfig({ name: Topics.IID_UNLOCK_CODE, realtimeEntity: 'IID_UnlockCode' })
@InterfaceDataStore(InterfaceName.UNLOCK_CODE)
export class IIDUnlockCodeStore extends EntityStore<IIDUnlockCodeState> {
  constructor() { super([]); }
}
